import { Button, ButtonGroup, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Text, useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from 'react-hook-form';
import reject from "../../../../assets/icon/reject.png";
import { instanceRequest } from '../../../../apis/vmRequests.api';
import { GET_REQUESTS } from '../../../../apis/constants.api';
import { STATUS } from '../constant';

export default function DeleteModal(props) {
  const { request, onClose } = props;
  const queryClient = useQueryClient();
  const { handleSubmit } = useForm();

  const toast = useToast();

  const { mutate: requestDeclined, isLoading } = useMutation({
    mutationFn: (data) => {
      return instanceRequest(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries([GET_REQUESTS]);
      onClose();


      if (data.data.message) {
        toast({
          title: "Success",
          description: data.data.message,
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top-right",
        });
      }
    }
  });

  const onDelete = async () => {
    requestDeclined({ id: request._id, status: STATUS.Rejected });
  };

  return (
    <Modal closeOnOverlayClick={false} onClose={onClose} size="lg" isOpen={true} isCentered >
      <form onSubmit={handleSubmit(onDelete)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Image alt='reject' src={reject} />
          </ModalHeader>
          <ModalCloseButton border="1px solid #868B944D" />
          <ModalBody>
            <Text fontSize="fs.18" fontWeight="fw.600">{`Delete ${request?.name} Instance`}</Text>
            <Text fontSize="fs.14" fontWeight="fw.400" color="#475467" mt="5px" >Are you sure you want to delete this instance?</Text>
            <ButtonGroup variant='outline' spacing='5' width="100%" my="18px">
              <Button {...actionButtonChakraProps} onClick={onClose}>Cancel</Button>
              <Button  {...actionButtonChakraProps} type='submit' background={'red.500'} color="white" _hover={{ background: "red.600" }}>
                Decline
                {isLoading && <Spinner size="sm" ml={2} />}
              </Button>
            </ButtonGroup>
          </ModalBody>
        </ModalContent>
      </form>
    </Modal>
  );
}

const actionButtonChakraProps = {
  fontWeight: "fw.600",
  width: "100%",
  borderRadius: "8px",
  height: "44px",
  fontSize: "fs.16",
};